import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * FICHAS DE ENCAMINHAMENTO AO CONSELHO TUTELAR — migração de
 * `MenuAcademico/FichaConselhoTutelar.aspx` e de `ProvidenciaConselhoTutelar.aspx`, que no legado
 * era uma JANELA separada e aqui é um card da própria tela.
 *
 * A permissão é PRÓPRIA da tela nova (`...NOVO_MENU_301300199`), vizinha da do legado
 * (`301300100`). Enquanto os dois sistemas convivem, a rede precisa poder liberar um sem o outro:
 * pilotar a tela nova sem mexer em quem usa a antiga, ou desativar a antiga sem derrubar a nova.
 * O `INSERT` na `Seg_Menu` está em
 * `saeweb-database-sql/consultebase/scripts/2026-09-23-Permissao-FichaConselhoTutelar.sql`.
 */
export default [
  {
    description: 'Fichas de Conselho Tutelar',
    path: '/academico/conselhotutelar',
    name: 'conselhotutelar',
    component: () => import('@/views/academico/conselhotutelar/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.FICHASDECONSELHOTUTELARNOVO_MENU_301300199],
    },
    goesToMenu: true,
  },
  {
    description: 'Ficha de Conselho Tutelar',
    path: '/academico/conselhotutelar/cadastro/:id?',
    parent: 'conselhotutelar',
    name: 'conselhotutelar_cadastro',
    component: () => import('@/views/academico/conselhotutelar/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.FICHASDECONSELHOTUTELARNOVO_MENU_301300199],
    },
  },
];
